import React, { useMemo } from 'react';
import Select from '@atlaskit/select';
import { formatOptionLabel as formatOptionLabelDefault } from '@atlassian/jira-issue-field-select-base/src/ui/format-option-label/index.tsx';
import { defaultSelectStyles } from '@atlassian/jira-issue-field-select-base/src/ui/react-select-styles/styled.tsx';
import type { Props } from './types.tsx';

const PriorityEdit = (props: Props) => {
	const {
		value,
		options,
		onChange,
		onFocus,
		onBlur,
		placeholder = '',
		autoFocus,
		inputId,
		isDropdownMenuFixedAndLayered,
		isClearable = false,
		isDisabled,
		isInvalid,
		isRequired,
		isSearchable,
		classNamePrefix,
		openMenuOnFocus,
		menuIsOpen,
		menuPortalTarget,
		ariaLabel,
		ariaLabelledBy,
		styles,
		formatOptionLabel = formatOptionLabelDefault,
		onCloseMenuOnScroll,
	} = props;

	const stylesMemoized = useMemo(() => {
		return { ...defaultSelectStyles, ...styles };
	}, [styles]);

	return (
		<Select
			inputId={inputId}
			value={value}
			options={options}
			placeholder={placeholder}
			// @ts-expect-error - TS2322 - Type '(arg1: Option) => void' is not assignable to type '(value: Option | null, action: ActionMeta<Option>) => void'.
			onChange={onChange}
			onFocus={onFocus}
			onBlur={onBlur}
			autoFocus={autoFocus}
			menuPosition={isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined}
			styles={stylesMemoized}
			// @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
			validationState={isInvalid === true ? 'error' : null}
			formatOptionLabel={formatOptionLabel}
			menuIsOpen={menuIsOpen}
			menuPortalTarget={menuPortalTarget}
			hideSelectedOptions
			closeMenuOnScroll={onCloseMenuOnScroll}
			required={isRequired}
			isClearable={isClearable}
			isDisabled={isDisabled}
			isSearchable={isSearchable}
			classNamePrefix={classNamePrefix}
			openMenuOnFocus={openMenuOnFocus}
			aria-label={ariaLabel}
			aria-labelledby={ariaLabelledBy}
		/>
	);
};

export default PriorityEdit;
